import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class RenderReport extends HttpForm {
    slug = false;
    report = false;
    parameters = {
        export_driver: 'MBLSolutions\\Report\\Driver\\QueuedExport\\CsvQueuedExport'
    };
    results = false;
    show_query = false;
    urlPrefix = '/api/report';
    app;
    constructor(app, report) {
        super();
        this.app = app;
        if (report.id) {
            this.slug = report.id;
        }
        this.urlPrefix = '/api/report/' + this.slug;
    }
    mount() {
        if (this.slug) {
            this.showReport().then(() => {
                this.setupReportRenderFields();
                this.setLoadingState(true);
            });
        }
    }
    setupReportRenderFields() {
        let self = this;
        if (this.report) {
            this.report.fields.forEach(function (field) {
                self.parameters[field.alias] = null;
            });
        }
    }
    reportHasResults() {
        return this.results !== false;
    }
    shouldShowQuery() {
        if (this.isAdminUser()) {
            return this.show_query;
        }
        return false;
    }
    toggleShowQuery() {
        this.show_query = !this.show_query;
    }
    editParameters() {
        this.unsetSubmitting();
        this.results = false;
    }
    showReport() {
        const url = this.urlPrefix;
        return axios.get(url)
            .then((response) => this.report = response.data.data)
            .catch(e => this.setError(e));
    }
    previewReport() {
        const url = this.urlPrefix + '/preview';
        this.setupFormSubmission();
        return axios.post(url, this.parameters)
            .then((response) => this.results = response.data)
            .catch(e => this.setError(e));
    }
    exportReport() {
        if (this.report) {
            const url = '/api/report/queue/' + this.report.id;
            this.setupFormSubmission();
            return axios.post(url, this.parameters)
                .then(() => { })
                .catch(e => this.setError(e));
        }
        throw Error('No Report Selected');
    }
    isAdminUser() {
        if (this.app && this.app.auth) {
            return this.app.auth.role === 'admin';
        }
        return false;
    }
}
